export const RecruitmentEvaluation = {
    path: '/recruitment_evaluations',
    name: 'recruitment_evaluations',
    component: () => import('@/views/Recruitment/Planning/EvaluationPage.vue'),
    children: [
        {
            path: '/recruitment_evaluations/view/:id',
            name: 'recruitment_evaluations.view',
            component: () => import('@/views/Recruitment/Planning/Form/EvaluationForm.vue'),
            props: {viewAction: true},
            children: [
                {
                    path: '/recruitment_evaluations/cv_techs/view/:id',
                    name: 'recruitment_evaluations.view.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                },
                {
                    path: '/evaluation_recruitment_plans/interview/edit/:id',
                    name: 'evaluation_recruitment_plans.interview.edit',
                    component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationRecruitmentInterviewForm.vue'),
                    props: {updateAction: true}
                },
                {
                    path: '/evaluation_recruitment_plans/interview/view/:id',
                    name: 'evaluation_recruitment_plans.interview.view',
                    component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationRecruitmentInterviewForm.vue'),
                    props: {viewAction: true}
                }
            ],
        },
        {
            path: '/recruitment_evaluations/lock/:id',
            name: 'recruitment_evaluations.lock',
            component: () => import('@/views/Recruitment/Planning/Form/EvaluationForm.vue'),
            props: {lockAction: true},
            children: [
                {
                    path: '/recruitment_evaluations/cv_techs/view/:id',
                    name: 'recruitment_evaluations.lock.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                }
            ],
        }
    ],
}